module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Olivia Taylor Fashion Dreams")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-one-best-things-happen-unexpectedly"
    }
  }, [_vm._v("Chapter One: Best Things Happen Unexpectedly")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-two-we-get-in-life-what-we-have-the-courage-to-ask-for"
    }
  }, [_vm._v("Chapter Two: We Get in Life What We Have the Courage to Ask For")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-three-great-success-is-achieved-only-via-teamwork"
    }
  }, [_vm._v("Chapter Three: Great Success Is Achieved Only via Teamwork")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-four-a-tested-emotional-bond-is-a-friendship-that-lasts-forever",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: A Tested Emotional Bond Is a Friendship That Lasts Forever")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-five-when-you-love-what-you-create-the-power-of-your-talent-becomes-irreplaceable",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: When You Love What You Create, the Power of Your Talent Becomes Irreplaceable")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-six-finding-real-love-is-something-we-all-deserve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Finding Real Love Is Something We All Deserve")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-seven-making-fundamental-decisions-leads-you-to-where-you-belong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Making Fundamental Decisions Leads You to Where You Belong")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-eight-inspiration-and-imagination-are-the-core-value-of-creativity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Inspiration and Imagination Are the Core Value of Creativity")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-nine-like-life-fashion-has-no-limits-if-there-isnt-a-way-then-you-must-create-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Like Life, Fashion Has No Limits – If There Isn’t a Way, Then You Must Create One")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0